/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiscordInfo,
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface DiscordInfoResponse
 */
export interface DiscordInfoResponse {
    /**
     * 
     * @type {DiscordInfo}
     * @memberof DiscordInfoResponse
     */
    discord?: DiscordInfo;
}

export function DiscordInfoResponseFromJSON(json: any): DiscordInfoResponse {
    return DiscordInfoResponseFromJSONTyped(json, false);
}

export function DiscordInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'discord': !exists(json, 'discord') ? undefined : DiscordInfoFromJSON(json['discord']),
    };
}

export function DiscordInfoResponseToJSON(value?: DiscordInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'discord': DiscordInfoToJSON(value.discord),
    };
}


